"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var OrgLegalDocsList = /*#__PURE__*/function () {
  OrgLegalDocsList.$inject = ["$rootScope", "modalService", "userService", "legalDocumentsService"];
  /* @ngInject */
  function OrgLegalDocsList($rootScope, modalService, userService, legalDocumentsService) {
    _classCallCheck(this, OrgLegalDocsList);
    this.modalService = modalService;
    this.userService = userService;
    this.legalDocsService = legalDocumentsService;
    this.flash = function (message, level) {
      return $rootScope.setFlashMessage(message, level);
    };
    this.userIsSuperAdmin = userService.matchesRoles({
      globalRole: 'superadmin'
    });
  }
  _createClass(OrgLegalDocsList, [{
    key: "$onChanges",
    value: function $onChanges(changes) {
      if (changes.organisation && this.organisation) {
        this.loadList();
      }
    }
  }, {
    key: "loadList",
    value: function loadList() {
      var _this = this;
      if (this.loading) return;
      this.loading = true;
      this.canModifyDocs = this.userIsSuperAdmin || this.userService.matchesRoles({
        orgRole: 'admin',
        orgId: this.organisation._id
      }) || this.userService.hasPermission('org_realms.write_org_members_legal_docs', {
        org_id: this.organisation._id
      });
      this.legalDocsService.getLegalDocumentsForOrg(this.organisation.name).then(function (docs) {
        return _this.legalDocs = docs;
      }).finally(function () {
        return _this.loading = false;
      });
    }
  }, {
    key: "docLink",
    value: function docLink(id) {
      return this.legalDocsService.getDocumentPreviewUrl(id);
    }
  }, {
    key: "createNewDoc",
    value: function createNewDoc() {
      var _this2 = this;
      if (!this.canModifyDocs) return;
      var org = this.organisation;
      this.modalService.openModalWithComponent({
        title: 'Create a new document',
        saveLabel: 'Create',
        component: 'bs-legal-doc-editor',
        args: {
          model: {}
        }
      }).then(function (model) {
        return _this2.legalDocsService.createLegalDocumentForOrg(org.name, model).then(function () {
          return _this2.flash('New document has been created.');
        }).catch(function () {
          return _this2.flash('There was an error. Please try again', 'danger');
        }).finally(function () {
          return _this2.loadList();
        });
      });
    }
  }, {
    key: "editDoc",
    value: function editDoc(id) {
      var _this3 = this;
      if (!this.canModifyDocs) return;
      this.legalDocsService.getLegalDocument(id).then(function (model) {
        return _this3.modalService.openModalWithComponent({
          title: 'Edit',
          component: 'bs-legal-doc-editor',
          args: {
            model: model
          }
        });
      }).then(function (model) {
        return _this3.legalDocsService.updateLegalDocument(id, model).then(function () {
          return _this3.flash('Changes have been saved.');
        }).catch(function () {
          return _this3.flash('There was an error. Please try again.', 'danger');
        }).finally(function () {
          return _this3.loadList();
        });
      });
    }
  }]);
  return OrgLegalDocsList;
}();
module.exports = angular.module('backstage.components.orgs.view-org.legal-docs-list', ['backstage.services']).component('bsOrgLegalDocsList', {
  templateUrl: '/src/angular/components/orgs/view-org/org-legal-docs-list/org-legal-docs-list.html',
  bindings: {
    organisation: '<'
  },
  controller: OrgLegalDocsList
}).name;